import React, {useEffect, useState} from 'react'
import './App.css'
import {Game} from "./model/Game.ts"
import {Repository} from "./Repository.ts"
import GameScreen from "./GameScreen.tsx"
import ReactGA from "react-ga4";
import GameGrid from "./GameGrid.tsx"
import {ColorKey} from "./LineupPmGrid.tsx"

const repo = new Repository();

function App() {
    const [error, setError] = useState<string | null>(null);
    const [selectedGame, setSelectedGame] = useState<Game | null>(null);

    // Handle deep linking: read gameId from URL params
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const gameIdFromUrl = urlParams.get('gameId');

        if (gameIdFromUrl && gameIdFromUrl.trim() !== '') {
            async function fetchGame(id: string) {
                const result = await repo.getGame(id);
                if (result.type === 'success') {
                    setSelectedGame(result.value);
                } else {
                    setError(`Game not found: ${id}`);
                }
            }

            fetchGame(gameIdFromUrl);
            ReactGA.send({hitType: "pageview", page: window.location.pathname + window.location.search});
        }
    },[]);

    // Handle browser back/forward buttons
    useEffect(() => {
        const handlePopState = () => {
            const urlParams = new URLSearchParams(window.location.search);
            const gameIdFromUrl = urlParams.get('gameId');

            if (gameIdFromUrl && gameIdFromUrl.trim() !== '') {
                async function fetchGame(id: string) {
                    const result = await repo.getGame(id);
                    if (result.type === 'success') {
                        setSelectedGame(result.value);
                    } else {
                        setError(`Game not found: ${id}`);
                    }
                }
                fetchGame(gameIdFromUrl);
            } else {
                setSelectedGame(null);
            }
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);

    async function handleGameSelect(gameId: string) {
        // Update URL to reflect selected game
        const url = new URL(window.location.href);
        if (gameId) {
            url.searchParams.set('gameId', gameId);
        } else {
            url.searchParams.delete('gameId');
        }
        window.history.pushState({}, '', url.toString());

        // Fetch and set the selected game
        if (gameId) {
            const result = await repo.getGame(gameId);
            if (result.type === 'success') {
                setSelectedGame(result.value);
            } else {
                setError(`Game not found: ${gameId}`);
            }
        } else {
            setSelectedGame(null);
        }
        ReactGA.send({ hitType: "pageview", page: url.pathname + url.search });
    }

    return (
        <>
            <div className="header-container" style={{
                justifyContent: 'space-between',
            }}>
                <div>
                <h1>Lineup +/-</h1>
                    {error && (
                        <div className="error">Error: {error}</div>
                    )}
                {selectedGame && <ColorKey/>}
            </div>
            </div>

            {selectedGame ? (
                <div className="game-screen-container">
                    <button
                        className="back-button"
                        onClick={() => {
                            setSelectedGame(null);
                            const url = new URL(window.location.href);
                            url.searchParams.delete('gameId');
                            window.history.pushState({}, '', url.toString());
                        }}
                    >
                        ← Back to Games
                    </button>
                    <GameScreen key={selectedGame.id} game={selectedGame} repo={repo}/>
                </div>
            ) : (
                <GameGrid repo={repo} onGameSelect={handleGameSelect} />
            )}
        </>
    )
}

export default App